module.exports = __webpack_public_path__ + "static/media/updates.899581e3.svg";